// eslint-disable-next-line no-unused-vars
import ChatUser from './ChatUser';
// eslint-disable-next-line no-unused-vars
import Message from './Message';

class Conversation {
    constructor({ id, participants, participantNames, lastMessage, lastMessageSenderId, lastMessageTimestamp, createdAt, type, name, adminIds }) {
        if (!id || !participants || participants.length < 1 || !createdAt || !type) {
            throw new Error('Conversation entity requires id, participants, createdAt, and type.');
        }

        this.id = id;
        this.participants = participants; // Array of user UIDs
        this.participantNames = participantNames || []; // Array of user names
        this.lastMessage = lastMessage;
        this.lastMessageSenderId = lastMessageSenderId;
        this.lastMessageTimestamp = lastMessageTimestamp;
        this.createdAt = createdAt;
        this.type = type; // 'one-to-one' or 'group'
        this.name = name; // For group chats
        this.adminIds = adminIds || []; // For group chats
    }
}

export default Conversation;
